import AntTag from 'antd/lib/tag';

export const Tag = AntTag;
